const INITIAL_STATE = {
  cnfs: [],
  cnfMonths: [],
  cnfBills: [],
  cnfExpenses: [],
  cnfSpendCash: [],
};

const cnfsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "GET_ALL_CUSTOMERS":
      return { ...state, cnfs: [...action.payload] };
    case "GET_ALL_CNF_BILLS":
      return { ...state, cnfBills: [...action.payload] };
    case "GET_ALL_CNF_SPEND_CASH":
      return { ...state, cnfSpendCash: [...action.payload] };
    case "GET_ALL_CNF_EXPENSES":
      return { ...state, cnfExpenses: [...action.payload] };
    case "ALL_MONTHS_CNF_BILL":
      return { ...state, cnfMonths: [...action.payload] };
    case "UPLOAD_CUSTOMER":
      return {
        ...state,
        cnfs: [action.payload, ...state.cnfs],
      };
    case "UPLOAD_CNF_BILL":
      return {
        ...state,
        cnfBills: [action.payload, ...state.cnfBills],
      };
    case "UPDATE_CUSTOMER":
      const filteredCnfArray = state.cnfs.filter(
        (cnf) => cnf.cnfId !== action.payload.cnfId
      );

      return {
        ...state,
        cnfs: [...filteredCnfArray, action.payload],
      };
    case "DELETE_CNF":
      const updatedcnfArray = state.cnfs.filter(
        (cnf) => cnf.cnfId !== action.payload
      );
      return {
        ...state,
        cnfs: [...updatedcnfArray],
      };
    default:
      return { ...state };
  }
};
export default cnfsReducer;
